export enum TaskEnum {
    UPLOAD, // La video est uploadé
    PROCESSING, // On separe la video et l'audio et on recupere une video clean sans flux PNG + 4 fichiers audios
    TRANSCRIPTION, // (ACTION) Transcrire le audio en texte horodaté
    TRANSLATION, // (ACTION) Traduire les textes sources vers la cible
    SUBTITLE_GENERATION, // Prend les json de replique et créer les SRTs
    VOICES_GENERATIONS, // Generation des voies a partir des json de replique
    VIDEO_EDITING // agloméra de le ensemble
}